import { useNavigate } from "react-router-dom";
import { OurServicesCard } from "./OurServicesStyled";
import { ServiceType } from "./types";

const OurServicesItems = ({
  services,
  index = 0,
}: {
  services: ServiceType;
  index?: number;
}) => {
  const navigate = useNavigate();

  return (
    <OurServicesCard
      onClick={() => {
        navigate(`/services/${services.id}`);
      }}
    >
      <div className="imageWrapper">
        <img src={services.image} alt={services.title} />
      </div>

      <span className="serviceNumber">0{index + 1}</span>

      <div className="contentWrapper">
        <h3>{services.title}</h3>
        <p>{services.firstParagraph}</p>
        <span className="viewLink">
          Learn More
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M5 12h14M12 5l7 7-7 7" />
          </svg>
        </span>
      </div>

      <div className="defaultContent">
        <h3>{services.title}</h3>
      </div>
    </OurServicesCard>
  );
};

export default OurServicesItems;
